import { render, staticRenderFns } from "./single.vue?vue&type=template&id=0dcb1892"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"
import style0 from "./single.vue?vue&type=style&index=0&id=0dcb1892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports